import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormLoaderService } from '../../services';

@Component({
  standalone: false,
  selector: 'app-form-loading-screen',
  templateUrl: './form-loading-screen.component.html',
  styleUrls: ['./form-loading-screen.component.scss']
})
export class FormLoadingScreenComponent implements OnInit {
  public subscriptions: any[] = <any>[];
  public showLoader: boolean = false;

  constructor(private loaderService: FormLoaderService, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    // Get initial value synchronously to avoid change detection issues
    this.showLoader = this.loaderService.status.value;

    this.subscriptions.push(
      this.loaderService.status.subscribe((val: boolean) => {
        // Skip if value hasn't changed to avoid unnecessary updates
        if (this.showLoader !== val) {
          setTimeout(() => {
            this.showLoader = val;
            // Mark for check instead of detectChanges to avoid triggering parent change detection
            this.cdr.markForCheck();
          }, 0);
        }
      })
    );
  }
  /**
   * On Destroy
   */
  ngOnDestroy() {
    this.subscriptions.forEach(el => el.unsubscribe());
  }
}
